import React, { useState } from "react";
import {
    Button, Row, Container, Col, Dropdown, DropdownButton,
    Tabs, Tab, Modal, Tooltip, OverlayTrigger
} from 'react-bootstrap';

import Question from './Question';
import SettingRandom from './Settings/SettingRandom'
import SettingLayout from './Settings/SettingLayout'
import SettingImage from './Settings/SettingImage'
import SettingVideo from './Settings/SettingVideo'
import SettingTimer from './Settings/SettingTimer'
// import SettingLabel from './Settings/SettingLabel'
import SettingPoint from './Settings/SettingPoint'
import SettingLimit from './Settings/SettingLimit'
import SettingOpenLimit from './Settings/SettingOpenLimit'
import SettingGroup from './Settings/SettingGroup'
import SettingArray from './Settings/SettingArray'
import MyListContentTitle from './MyListContentInputs/MyListContentTitle'
import { useMappedState, useDispatch } from 'redux-react-hook';
import { Image, Justify, Trash2Fill, Files, ThreeDotsVertical } from 'react-bootstrap-icons';
// import { render } from "@testing-library/react";
import Enums from '../../../enums';

export default function QuestListContent(props) {
    const pid = useMappedState(state => state.pid);
    const tmpItems = useMappedState(state => state.tmpItems);
    const id = props.index;
    const data = tmpItems[id];
    const [isShowQuestionModal, setIsShowQuestionModal] = useState(false);
    const [isShowOptionModal, setIsShowOptionModal] = useState(false);
    const q_type = (data && data.cf) ? data.cf.q_type : 1;
    const E_q_type = Enums.E_QUESTION_TYPE_TEXT[q_type];
    const dispatch = useDispatch();
    // console.log(id, data, q_type, E_q_type);
    // const tmpKeyIndex = useMappedState(state => state.tmpKeyIndex);
    // const dataIndex = tmpKeyIndex[props.id];
    // let data = tmpItems[dataIndex];
    // const dispatch = useDispatch();
    // const id = props.index;
    // console.log(props);

    // useEffect(() => {
    //     console.log(props, data)
    //     // 使用瀏覽器 API 更新文件標題
    //     // document.title = `You clicked ${count} times`;
    //     // console.log("getDerivedStateFromProps", props, state)
    //     // if (state.items==null) {
    //     //     return {
    //     //         items: props.items,
    //     //         tmpItems: props.items
    //     //     }
    //     // }
    //     // return null
    // });

    function onSelect(e) {
        // console.log("onSelect", e);
        try {
            let tmp = [...tmpItems];
            // console.log(tmp, questionIndex);
            tmp[id].cf.q_type = parseInt(e);

            if (null == tmp[id].cf) tmp[id].cf = {};
            if (null == tmp[id].cf.q_type || isNaN(tmp[id].cf.q_type)) tmp[id].cf.q_type = 1;
            if (null == tmp[id].cf.parameters) tmp[id].cf.parameters = {};
            switch (tmp[id].cf.q_type) {
                case Enums.E_QUESTION_TYPE_INDEX.SINGLE:
                    break;
                case Enums.E_QUESTION_TYPE_INDEX.MULTIPLE:
                    if (null == tmp[id].cf.parameters.group) tmp[id].cf.parameters.group = [];
                    if (null == tmp[id].cf.parameters.limit) tmp[id].cf.parameters.limit = { ty: 0, min: 1, max: tmp[id].op ? tmp[id].op.length : 1 };
                    break;
                case Enums.E_QUESTION_TYPE_INDEX.DRAG:
                    // if (null == tmp[id].cf.parameters.group) tmp[id].cf.parameters.group = [];
                    // if (null == tmp[id].cf.parameters.limit) tmp[id].cf.parameters.limit = { min: 1, max: 3 };
                    break;
                case Enums.E_QUESTION_TYPE_INDEX.OPEN:
                    // console.log(tmp[id].cf.q_type);
                    if (null == tmp[id].cf.parameters.group) tmp[id].cf.parameters.group = [];
                    if (null != tmp[id].op && tmp[id].op.length > 0) {
                        tmp[id].op.forEach((val, index) => {
                            if (!val.limit) tmp[id].op[index].limit = { min: 0, max: 1024 }
                        })
                    } else {
                        tmp[id].op = [{
                            limit: { min: 0, max: 1024 },
                            na: "name",
                            o_type: 0
                        }]
                    }
                    break;
                case Enums.E_QUESTION_TYPE_INDEX.ARRAY:
                    //API目前沒有提供單多選, 須設定右列固定值 limit={min:1,max:1}, group=[], row_type=1

                    // if (null == tmp[id].cf.parameters.group) tmp[id].cf.parameters.group = [];
                    if (null == tmp[id].cf.parameters.row_op) tmp[id].cf.parameters.row_op = [""];
                    if (null != tmp[id].op && tmp[id].op.length > 0) {
                        // if (tmp[id].cf.parameters.row_op == 1) {
                        tmp[id].op.forEach((val, index) => {
                            // if (!val.group) tmp[id].op[index].group = [];
                            // if (!val.limit) tmp[id].op[index].limit = { min: 1, max: 1 };
                            tmp[id].op[index].limit = { min: 1, max: 1 };
                            tmp[id].op[index].group = [];
                            // if (!val.o_type) tmp[id].op[index].o_type = 0; //server不吃
                        })
                        // }
                    } else {
                        tmp[id].op = [{
                            // limit: { min: 0, max: 1024 },
                            na: "name",
                            limit: { min: 1, max: 1 },
                            group: [],
                            // o_type: 0 //server不吃
                        }]
                        // if (tmp[id].cf.parameters.row_op == 1) {
                        //     tmp[id].op = [{
                        //         na: "name"
                        //     }]
                        // } else {
                        //     tmp[id].op = [{
                        //         // limit: { min: 0, max: 1024 },
                        //         na: "name",
                        //         group: []
                        //     }]
                        // }
                    }
                    // if (null == tmp[id].cf.parameters.row_type) tmp[id].cf.parameters.row_type = 1;
                    tmp[id].cf.parameters.row_type = 1;
                    break;
                case Enums.E_QUESTION_TYPE_INDEX.RULER:
                    tmp[id].op = [{
                        na: "name",
                        min: 0,
                        max: 24,
                        interval: 1,
                        unit: "單位"
                    }];
                    break;
            }

            //------ check jump rule -----
            console.log("check jump rule", JSON.stringify(tmp[id].ru));
            switch (tmp[id].cf.q_type) {
                case Enums.E_QUESTION_TYPE_INDEX.SINGLE:
                    if (null != tmp[id].ru
                        && null != tmp[id].ru.route
                        && 2 == tmp[id].ru.route.ty
                        && null != tmp[id].ru.route.ta) {
                        tmp[id].ru.route.ty = 1;
                        console.log("fix");
                    }
                    break;
                case Enums.E_QUESTION_TYPE_INDEX.MULTIPLE:
                    if (null != tmp[id].ru
                        && null != tmp[id].ru.route
                        && 1 == tmp[id].ru.route.ty
                        && null != tmp[id].ru.route.ta) {
                        //複選題僅能有一個跳題號
                        let tt = [], next = id + 1;
                        tmp[id].ru.route.ta.forEach(v => { if (v != next && tt.indexOf(v) < 0) { tt.push(v) } })
                        if (tt.length == 0) {
                            console.log("no jump");
                            tmp[id].ru.route = { ty: 0 };
                        } else if (tt.length == 1) {
                            tmp[id].ru.route.ty = 2;
                            tmp[id].ru.route.pr = tt[0];
                        } else {
                            alert("題目" + next + "有多個跳題目標(" + tt.join(",") + "), 無法設定複選");
                            return;
                        }

                        console.log("fix", tmp[id].ru);
                    }
                    break;
                default:
                    console.log("default");
                    if (null != tmp[id].ru) {
                        tmp[id].ru = { route: { ty: 0 }, bonus: { ty: 0 } };
                        console.log("fix");
                    }
                    break;
            }

            //-------- 修正其他 --------
            //修正下拉改其他op補o_type
            if (Enums.E_QUESTION_TYPE_INDEX.DRAG != tmp[id].cf.q_type) {
                if (null != tmp[id].op && tmp[id].op.length > 0) {
                    tmp[id].op.forEach((val, index) => {
                        //修正選項type為空
                        if (null == val.o_type) tmp[id].op[index].o_type = 0;
                    })
                }
            }

            switch (tmp[id].cf.q_type) {
                case Enums.E_QUESTION_TYPE_INDEX.OPEN:
                    //修正bonus
                    //data.cf.parameters.bonus
                    // if (null != tmp[id].cf.parameters) {
                    //     tmp[id].cf.parameters.bonus = {bonus: 0, has_bonus: 0};
                    // }

                    if (null != tmp[id].op && tmp[id].op.length > 0) {
                        tmp[id].op.forEach((val, index) => {
                            //修正limit
                            if (null == val.limit) tmp[id].op[index].limit = { min: 0, max: 1024 };
                        })
                    } else {
                        tmp[id].op = [{
                            limit: { min: 0, max: 1024 },
                            na: "name",
                            o_type: 0
                        }]
                    }
                    break;
            }
            console.log(tmp[id]);

            dispatch({ type: "UPDATE_TMP_ITEM", data: tmp });
            console.log(tmp);
        } catch (e) {
            console.warn(e.stack)
        }
    }

    function onTitleChange(e) {
        try {
            // console.log("onTitleChange", e.target.value);

            let tmp = [...tmpItems];
            // console.log(tmp, questionIndex);
            tmp[id].ma.content = e.target.value;
            dispatch({ type: "UPDATE_TMP_ITEM", data: tmp });
        } catch (e) {
            console.warn(e.stack)
        }
    }

    function toggleShowQuestionModal() {
        setIsShowQuestionModal(!isShowQuestionModal)
    }
    function onUpdateQuestionModal() {
        toggleShowQuestionModal()
    }

    function renderQuestionPanel() {
        if (null == data) {
            return <div>No Data</div>
        }
        let tmpRandom, tmpOpLimit, tmpLayout, tmpMa, tmpType, tmpPoint, tmpLimit, tmpGroup, tmpOps = null;
        try {
            tmpLimit = data.cf.parameters.limit;
            tmpOpLimit = data.op && data.op.length > 0 ? data.op[0].limit : { min: -1, max: -1 };
            tmpRandom = data.cf.parameters.random;
            tmpLayout = data.cf.parameters.layout;
            tmpPoint = data.cf.parameters.bonus;
            tmpGroup = data.cf.parameters.group;
            tmpOps = data.op;
            tmpMa = data.ma;
            tmpType = data.cf.q_type == null ? 1 : data.cf.q_type;
        } catch (e) { }

        let tabs = [];
        tabs.push(<Tab key={"opt-" + id + "-" + 2} className="pt-2" eventKey="pic" title="圖片">
            <SettingImage index={props.index} image={tmpMa.image} images={tmpMa.images} pid={pid} /></Tab>);
        tabs.push(<Tab key={"opt-" + id + "-" + 3} className="pt-2" eventKey="href" title="影片超連結">
            <SettingVideo index={props.index} data={tmpMa.video} /></Tab>);
        tabs.push(<Tab key={"opt-" + id + "-" + 5} className="pt-2" eventKey="schedule" title="題目定時">
            <SettingTimer index={props.index} data={tmpMa.timer} /></Tab>);

        return (
            <Modal className="EZC-modal-question"
                size="xl" show={isShowQuestionModal} onHide={toggleShowQuestionModal} centered>
                <Modal.Body>
                    <Tabs defaultActiveKey="pic" id={props.id + "-tab"}>
                        {tabs}
                    </Tabs>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={onUpdateQuestionModal}>
                        確定
                    </Button>
                </Modal.Footer>
            </Modal>);
    }

    function toggleShowOptionModal() {
        setIsShowOptionModal(!isShowOptionModal)
    }
    function onUpdateOptionModal() {
        toggleShowOptionModal()
    }
    function renderOptionPanel() {
        if (null == data) {
            return <div>No Data</div>
        }
        let tmpRandom, tmpOpLimit, tmpLayout, tmpMa, tmpType, tmpPoint, tmpLimit, tmpGroup, tmpOps, tmpRandomLimit, tmpArray = null;
        try {
            tmpLimit = data.cf.parameters.limit;
            tmpOpLimit = data.op && data.op.length > 0 ? data.op[0].limit : { min: -1, max: -1 };
            tmpRandom = data.cf.parameters.random;
            tmpRandomLimit = data.op ? data.op.length : 0;
            tmpLayout = data.cf.parameters.layout;
            tmpPoint = data.cf.parameters.bonus;
            tmpGroup = data.cf.parameters.group;
            tmpOps = data.op;
            tmpMa = data.ma;
            tmpType = data.cf.q_type == null ? 1 : data.cf.q_type;
            tmpArray = data.cf.parameters.row_op == null ? [""] : data.cf.parameters.row_op;
        } catch (e) { }


        let tabs = [];
        let defaultKey = "";
        switch (tmpType) {
            case 0:
            case Enums.E_QUESTION_TYPE_INDEX.SINGLE:
                defaultKey = "display";
                tabs.push(<Tab key={"opt-" + id + "-" + 4} className="pt-2" eventKey="display" title="選項呈現方式">
                    <SettingLayout index={props.index} data={tmpLayout} /></Tab>);
                tabs.push(<Tab key={"opt-" + id + "-" + 1} className="pt-2" eventKey="random" title="隨機設定">
                    <SettingRandom index={props.index} data={tmpRandom} max={tmpRandomLimit} /></Tab>);
                // tabs.push(<Tab key={"opt-" + id + "-" + 6} className="pt-2" eventKey="tag" title="標籤">
                //     <SettingLabel index={props.index} data={tmpMa.tag} /></Tab>);
                tabs.push(<Tab key={"opt-" + id + "-" + 7} className="pt-2" eventKey="pt" title="額外贈點">
                    <SettingPoint index={props.index} data={tmpPoint} /></Tab>);
                break;
            case Enums.E_QUESTION_TYPE_INDEX.MULTIPLE:
                defaultKey = "display";
                tabs.push(<Tab key={"opt-" + id + "-" + 4} className="pt-2" eventKey="display" title="選項呈現方式">
                    <SettingLayout index={props.index} data={tmpLayout} /></Tab>);
                tabs.push(<Tab key={"opt-" + id + "-" + 1} className="pt-2" eventKey="random" title="隨機設定">
                    <SettingRandom index={props.index} data={tmpRandom} /></Tab>);
                // tabs.push(<Tab key={"opt-" + id + "-" + 6} className="pt-2" eventKey="tag" title="標籤">
                //     <SettingLabel index={props.index} data={tmpMa.tag} /></Tab>);
                tabs.push(<Tab key={"opt-" + id + "-" + 7} className="pt-2" eventKey="pt" title="額外贈點">
                    <SettingPoint index={props.index} data={tmpPoint} /></Tab>);
                tabs.push(<Tab key={"opt-" + id + "-" + 8} className="pt-2" eventKey="limit" title="選項限制">
                    <SettingLimit index={props.index} data={tmpLimit} /></Tab>);
                tabs.push(<Tab key={"opt-" + id + "-" + 9} className="pt-2" eventKey="group" title="互斥">
                    <SettingGroup index={props.index} data={tmpGroup} ops={tmpOps}></SettingGroup></Tab>);
                break;
            case Enums.E_QUESTION_TYPE_INDEX.DRAG:
                defaultKey = "pt";
                // tabs.push(<Tab key={"q-"+id+"-opt-" + pid + "-" + 1} className="pt-2" eventKey="random" title="隨機設定">
                //     <SettingRandom index={props.index} data={tmpRandom} /></Tab>);
                // tabs.push(<Tab key={"q-"+id+"-opt-" + pid + "-" + 4} className="pt-2" eventKey="display" title="選項呈現方式">
                //     <SettingLayout index={props.index} data={tmpLayout} /></Tab>);
                // tabs.push(<Tab key={"opt-" + id + "-" + 6} className="pt-2" eventKey="tag" title="標籤">
                //     <SettingLabel index={props.index} data={tmpMa.tag} /></Tab>);
                tabs.push(<Tab key={"opt-" + id + "-" + 7} className="pt-2" eventKey="pt" title="額外贈點">
                    <SettingPoint index={props.index} data={tmpPoint} /></Tab>);
                break;
            case Enums.E_QUESTION_TYPE_INDEX.OPEN:
                defaultKey = "limit";
                tabs.push(<Tab key={"opt-" + id + "-" + 8} className="pt-2" eventKey="limit" title="選項限制">
                    <SettingOpenLimit index={props.index} data={tmpOpLimit} /></Tab>);
                // tabs.push(<Tab key={"opt-" + id + "-" + 6} className="pt-2" eventKey="tag" title="標籤">
                //     <SettingLabel index={props.index} data={tmpMa.tag} /></Tab>);
                tabs.push(<Tab key={"opt-" + id + "-" + 7} className="pt-2" eventKey="pt" title="額外贈點">
                    <SettingPoint index={props.index} data={tmpPoint} /></Tab>);
                break;
            case Enums.E_QUESTION_TYPE_INDEX.RULER:
                defaultKey = "no_function";
                tabs.push(<Tab key={"opt-" + id + "-" + 999} className="pt-2" eventKey="no_function" title="無功能">
                </Tab>);
                break;
            case Enums.E_QUESTION_TYPE_INDEX.ARRAY:
                defaultKey = "array";
                //矩陣選項
                tabs.push(<Tab key={"opt-" + id + "-" + 10} className="pt-2" eventKey="array" title="矩陣選項">
                    <SettingArray index={props.index} data={tmpArray} /></Tab>);
                //欄類型選項
                //選項區間
                // tabs.push(<Tab key={"opt-" + id + "-" + 9} className="pt-2" eventKey="group" title="互斥">
                //     <SettingGroup index={props.index} data={tmpGroup} ops={tmpOps}></SettingGroup></Tab>);
                break;
        }

        return (
            <Modal className="EZC-modal-question"
                size="xl" show={isShowOptionModal} onHide={toggleShowOptionModal} centered>
                <Modal.Body>
                    <Tabs defaultActiveKey={defaultKey} id={props.id + "-tab"}>
                        {tabs}
                    </Tabs>
                </Modal.Body>
                <Modal.Footer>
                    {/* <Button variant="secondary" onClick={onHidePwd}>
                    取消
                    </Button> */}
                    <Button variant="primary" onClick={onUpdateOptionModal}>
                        確定
                    </Button>
                </Modal.Footer>
            </Modal>);
    }

    function render() {
        let opts = Object.keys(Enums.E_QUESTION_TYPE_TEXT).map(function (key) {
            return <Dropdown.Item key={key} eventKey={key}>{Enums.E_QUESTION_TYPE_TEXT[key]}</Dropdown.Item>
        });
        let tmpMa = {};
        try {
            tmpMa = data.ma;
        } catch (e) {
        }

        return (
            <>
                <Container>
                    <Row className="mb-10">
                        {/* <Col xs={9} className="text-left">題目{props.index + 1}:{E_q_type} </Col> */}
                        {/* <Col xs={9} className="text-left">{props.index + 1}. {tmpMa.content} </Col> */}
                        <MyListContentTitle
                            key={props.index}
                            index={props.index + 1}
                            title={tmpMa.content}
                            onChange={onTitleChange} />
                        <Col xs={1} className="text-right">
                            <span
                                variant="link"
                                size="sm"
                                className="neg-mt-1"
                                onClick={toggleShowQuestionModal}>

                                <OverlayTrigger
                                    key={"step2"}
                                    placement="top"
                                    overlay={
                                        <Tooltip id={`tooltip-step2`}>圖片/影片連結設定</Tooltip>
                                    }
                                >
                                    <Image />
                                </OverlayTrigger>
                            </span>
                        </Col>
                        <Col xs={3} className="text-right">
                            <DropdownButton
                                className="btn-block no-bg"
                                size="sm"
                                variant="success"
                                title={E_q_type}
                                onSelect={onSelect}
                            >
                                {opts}
                            </DropdownButton>
                        </Col>
                    </Row>
                    <hr />
                    <Row>
                        <Col>
                            <Question index={props.index} />
                        </Col>
                    </Row>
                </Container>
                {/* <Row>
                    <Col className="text-right">
                        <Button
                            variant="link"
                            size="sm"
                            className="neg-mt-1"
                            onClick={toggleShowOptionModal}>
                            <ThreeDotsVertical />
                        </Button>
                    </Col>
                </Row> */}
                {renderQuestionPanel()}
                {renderOptionPanel()}
                <Row>
                    <Col xs={3}></Col>
                    <Col className="text-center" {...props.dragProrp}>
                        <Justify />
                    </Col>
                    <Col xs={3} className="text-right">
                        <span className="p-2">
                            <OverlayTrigger
                                key={"step2"}
                                placement="top"
                                overlay={
                                    <Tooltip id={`tooltip-step2`}>刪除</Tooltip>
                                }
                            >
                                <Trash2Fill onClick={props.onTrash} />
                            </OverlayTrigger>
                        </span>
                        <span className="p-2">
                            <OverlayTrigger
                                key={"step2"}
                                placement="top"
                                overlay={
                                    <Tooltip id={`tooltip-step2`}>複製</Tooltip>
                                }
                            >
                                <Files onClick={props.onCopy} />
                            </OverlayTrigger>
                        </span>
                        <span className="p-2">
                            <OverlayTrigger
                                key={"step2"}
                                placement="top"
                                overlay={
                                    <Tooltip id={`tooltip-step2`}>功能設定</Tooltip>
                                }
                            >
                                <ThreeDotsVertical onClick={toggleShowOptionModal} />
                            </OverlayTrigger>
                        </span>
                    </Col>
                </Row>
            </>
        );
    }

    return render();
}